import { enTranslations } from './translations/en.js';
import { bgTranslations } from './translations/bg.js';

export const translations = {
    en: enTranslations,
    bg: bgTranslations,
}

